import { Box, Pagination, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { fetchData } from '../utils/fetchData'
import ExerciseCard from './ExercisesCard'

const Exercises = ({ data, item, setItem, search, setSearch, bodyPart ,setBodyPart}) => {
  // console.log(data[0].gifUrl);
  console.log(item);
  const[filtData,setfiltData]=useState([ ])
    useEffect(()=>{
      const data = fetchData.data
      if(bodyPart ==="all"){
        const filterData = data.filter((items) => (
          items.target.toLowerCase().includes(item)
          || items.bodyPart.toLowerCase().includes(item)
        ))
        setfiltData(filterData)

      }else{
            const filterData = data.filter((item) => (
          item.name.toLowerCase().includes(search)
          || item.target.toLowerCase().includes(search)
          || item.equipment.toLowerCase().includes(search)
          || item.bodyPart.toLowerCase().includes(search)
      ))
      setfiltData(filterData)
      }
     
    },[item])
    
  const [currentPage, setCurrentPage] = useState(1);

  const lastPage=6*currentPage
  const firstpage=lastPage-6
  const pageToshow=data.slice(firstpage,lastPage+1)

  function paginate(e,value){
    setCurrentPage(value)
    window.scrollTo({top:1800,behavior: 'smooth'})
  }

  return (
    <div>
      <Box id="exercises" sx={{ mt: { lg: '109px' } }} mt="50px" p="20px">
        <Typography variant="h4" fontWeight="bold" sx={{ fontSize: { lg: '44px', xs: '30px' } }} mb="46px">Showing Results</Typography>
        <Stack direction="row" sx={{ gap: { lg: '107px', xs: '50px' } }} flexWrap="wrap" justifyContent="center">
          {
            pageToshow.map((exer)=>(
              <ExerciseCard exercise ={exer}/>
            ))
          }
        </Stack>
        <Stack sx={{ mt: { lg: '114px', xs: '70px' } }} alignItems="center">
          {data.length  > 5 && (
            <Pagination
              color='standard'
              shape='rounded'
              count={Math.ceil(data.length/6  )}
              onChange={paginate}
              size="large"
              page={currentPage}
            />
          )}
        </Stack>
      </Box>
    </div>
  )
}

export default Exercises
